if (!customElements.get('collection-switcher')) {
  customElements.define(
    'collection-switcher',
    class CollectionSwitcher extends HTMLElement {
      constructor() {
        super();
        this.switchCollection = this.switchCollection.bind(this);
      }

      connectedCallback() {
        this._initProperties();
        this._attachEventListeners();
      }

      _initProperties() {
        this.sectionId = this.dataset.sectionId;
        this.section = document.querySelector(`[data-section-id="${this.sectionId}"]`);

        if (!this.section) {
          return;
        }

        this.tabs = this.section.querySelectorAll('.collection-tab');
        this.collections = this.section.querySelectorAll('.collection-products');
        this.viewAllButtons = this.section.querySelectorAll('.collection-view-all');
      }

      _attachEventListeners() {
        this.tabs.forEach(tab => {
          tab.addEventListener('click', (e) => this.switchCollection(e.currentTarget));
        });
      }

      switchCollection(clickedTab) {
        const blockId = clickedTab.dataset.blockId;

        this.tabs.forEach(tab => tab.classList.remove('active'));
        clickedTab.classList.add('active');

        this.collections.forEach(collection => {
          if (collection.dataset.blockId === blockId) {
            collection.classList.remove('hidden');
          } else {
            collection.classList.add('hidden');
          }
        });

        this.viewAllButtons.forEach(button => {
          if (button.dataset.blockId === blockId) {
            button.classList.remove('hidden');
          } else {
            button.classList.add('hidden');
          }
        });
      }
    }
  );
}
